!<template>
  <div>
    <v-row v-for="(ing, index) in Inventory" :key="'Inventory' + index">
      <v-col cols="12" md="2">
        <v-text-field v-model="Inventory[index].Name" :label="'Inventory Name ' + (index + 1)"></v-text-field>
      </v-col>
      <v-col cols="12" md="1">
        <v-text-field v-model="Inventory[index].Type" label="Type"></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field v-model="Inventory[index].Description" label="Description"></v-text-field>
      </v-col>
      <v-col cols="12" md="1">
        <v-text-field v-model="Inventory[index].Qty" label="Qty"></v-text-field>
      </v-col>
      <v-col cols="12" md="1">
        <v-text-field v-model="Inventory[index].Price" label="Price"></v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field v-model="Inventory[index].Url" label="Url"></v-text-field>
      </v-col>
      <v-col cols="12" md="1">
        <v-btn icon color="red" class="mt-4" @click="removeInventory(index)">
          <v-icon>mdi-minus-box</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>Add Inventory
      <v-btn icon color="primary" @click="addInventory()">
        <v-icon>mdi-plus-box</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  props: ["Inventory"],
  data: () => ({
    // TempTown: null,
  }),
  methods: {
    removeInventory(index) {
      this.Inventory.splice(index, 1);
    },
    addInventory() {
      this.Inventory.push({});
    }
  }
};
</script>
